<template>
    <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal"
        modal-size="full-width">
        <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `trips/${inputs.id}` : `trips`'>
                <div class="row">
                    <div class="col-12">
                        <div style="background-color: #F1F5FA;" class="p-2 mb-3">
                            <h6>{{ $t('general_informations') }}</h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Loading Date Input -->
                        <div class="form-group">
                            <label for="loading_date">{{ $t('loading_date') }}</label>
                            <app-input id="loading_date" type="date" v-model="inputs.loading_date"
                                :placeholder="$t('loading_date')" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Lot Number Input -->
                        <div class="form-group">
                            <label for="inputs_lot_number">{{ $t('lot_number') }}
                                <span style="color: crimson">*</span></label>
                            <app-input id="inputs_lot_number" type="text" v-model="inputs.lot_number"
                                :placeholder="$t('lot_number')" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Client Select Input -->
                        <div class="form-group">
                            <label for="client">{{ $t('client') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="client" v-model="inputs.client_id" :list="clientList"
                                    list-value-field="name" :placeholder="$t('client')" type="search-select"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Vehicule Type Select Input -->
                        <div class="form-group">
                            <label for="vehicule">{{ $t('vehicule_type') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="vehicule" v-model="inputs.vehicule_type_id"
                                    :list="vehiculeList" list-value-field="name" :placeholder="$t('vehicule_type')"
                                    type="search-select" :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Product Select Input -->
                        <div class="form-group">
                            <label for="product">{{ $t('product') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="product" v-model="inputs.product_id" :list="productList"
                                    list-value-field="name" :placeholder="$t('product')" type="search-select"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Dispatch Date Input -->
                        <div class="form-group">
                            <label for="dispatched_at">{{ $t('dispatched_at') }}</label>
                            <app-input id="dispatched_at" type="date" v-model="inputs.dispatched_at"
                                :placeholder="$t('dispatched_at')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Site Select Input -->
                        <div class="form-group">
                            <label for="site">{{ $t('site') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="site" v-model="inputs.site_id" :list="siteList"
                                    list-value-field="name" :placeholder="$t('site')" type="search-select"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Transporter Select Input -->
                        <div class="form-group">
                            <label for="transporter">{{ $t('transporter') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="transporter" v-model="inputs.transporter_id"
                                    :list="transporterList" list-value-field="name" :placeholder="$t('transporter')"
                                    type="search-select" :required="true" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Location Select Input -->
                        <div class="form-group">
                            <label for="location">{{ $t('location') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="location" v-model="inputs.location_id" :list="locationList"
                                    list-value-field="name" :placeholder="$t('location')" type="search-select"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Destination Select Input -->
                        <div class="form-group">
                            <label for="destination">{{ $t('destination') }}</label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="destination" v-model="inputs.destination_id"
                                    :list="destinationList" list-value-field="name" :placeholder="$t('destination')"
                                    type="search-select" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-md-4">
                        <div class="form-group">
                            <label for="transit">{{ $t('transit') }}</label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="transit" v-model="inputs.transit_id"
                                    :list="transitList" list-value-field="name" :placeholder="$t('transit')"
                                    type="search-select"/>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-md-4">
                        <!-- Status Select Input -->
                        <div class="form-group">
                            <label for="status">{{ $t('status') }}
                                <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="status" v-model="inputs.status_id" :list="statusList"
                                    list-value-field="name" :placeholder="$t('status')" type="search-select"
                                    :required="true" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div style="background-color: #F1F5FA;" class="p-2 mb-3">
                            <div class="row">
                                <div class="col-md-9">
                                    <h6>{{ $t('convoy_informations') }}</h6>
                                </div>
                                <div class="col-md-3 text-right">
                                    <button class="btn btn-sm btn-primary" v-if="this.$can('create_escorters')"
                                        type="button" @click="openEscorterModal">
                                        <app-icon name="plus" :size="16" /> {{ $t('new_escorter') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Horse Text Input -->
                        <div class="form-group">
                            <label for="horse">{{ $t('horse') }}
                                <span style="color: crimson">*</span></label>
                            <app-input id="horse" type="text" v-model="inputs.horse" :placeholder="$t('horse')"
                                :required="true" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Trailer_one Text Input -->
                        <div class="form-group">
                            <label for="trailer_one">{{ $t('trailer_one') }}</label>
                            <app-input id="trailer_one" type="text" v-model="inputs.trailer_one"
                                :placeholder="$t('trailer_one')" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Trailer_two Text Input -->
                        <div class="form-group">
                            <label for="trailer_two">{{ $t('trailer_two') }}</label>
                            <app-input id="trailer_two" type="text" v-model="inputs.trailer_two"
                                :placeholder="$t('trailer_two')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Escorter Select Input -->
                        <div class="form-group">
                            <label for="escorter">{{ $t('escorter') }}</label>
                            <app-input class="w-100" id="escorter" v-model="inputs.escorter_id" :list="escorterList"
                                :placeholder="$t('escorter')" list-value-field="name" type="search-select" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Driver Text Input -->
                        <div class="form-group">
                            <label for="driver">{{ $t('driver') }}</label>
                            <app-input id="driver" type="text" v-model="inputs.driver_name"
                                :placeholder="$t('driver')" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Driver Phone Number Input -->
                        <div class="form-group">
                            <label for="driver_number">
                                {{ $t('driver_number') }}
                            </label>
                            <app-input id="driver_number" type="tel-input" v-model="inputs.driver_number" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Bunbles Text Input -->
                        <div class="form-group">
                            <label for="bundles">{{ $t('bundles') }}</label>
                            <app-input id="bundles" type="number" v-model="inputs.bundles"
                                :placeholder="$t('bundles')" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Net Weight Text Input -->
                        <div class="form-group">
                            <label for="net_weight">{{ $t('net_weight') }}</label>
                            <app-input id="net_weight" type="number" v-model="inputs.net_weight"
                                :placeholder="$t('net_weight')" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- Gross Weight Number Text Input -->
                        <div class="form-group">
                            <label for="gross_weight">{{ $t('gross_weight') }}</label>
                            <app-input id="gross_weight" type="number" v-model="inputs.gross_weight"
                                :placeholder="$t('gross_weight')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <!-- Exit Date Input -->
                        <div class="form-group">
                            <label for="exit_date">{{ $t('exit_date') }}</label>
                            <app-input id="exit_date" type="date" v-model="inputs.exit_date"
                                :placeholder="$t('exit_date')" :disabled="!this.$can('update_exit_date')" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div style="background-color: #F1F5FA;" class="p-2 mb-3">
                                <label for="comment" class="h6">{{ $t('comment') }}</label>
                            </div>
                            <app-input id="comment" v-model="inputs.comment" type="text-editor" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { mapState } from 'vuex';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'TripAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            clientList: state => state.selects.clientList,
            productList: state => state.selects.productList,
            vehiculeList: state => state.selects.vehiculeList,
            siteList: state => state.selects.siteList,
            transporterList: state => state.selects.transporterList,
            locationList: state => state.selects.locationList,
            destinationList: state => state.selects.destinationList,
            transitList: state => state.selects.transitList,
            statusList: state => state.selects.statusList,
            escorterList: state => state.selects.escorterList,
        }),
    },
    data() {
        return {
            preloader: false,
            loadingYearList: [
                { id: 2024, name: 2024 },
            ],
            loadingMonthList: [
                { id: 1, name: this.$t('january') },
                { id: 2, name: this.$t('february') },
                { id: 3, name: this.$t('march') },
                { id: 4, name: this.$t('april') },
                { id: 5, name: this.$t('may') },
                { id: 6, name: this.$t('june') },
                { id: 7, name: this.$t('july') },
                { id: 8, name: this.$t('august') },
                { id: 9, name: this.$t('september') },
                { id: 10, name: this.$t('october') },
                { id: 11, name: this.$t('november') },
                { id: 12, name: this.$t('december') },
            ],
            modalId: 'trip-add-edit-modal',
            inputs: {
                loading_year: 2024,
                loading_date: null,
                dispatched_at: null,
            },
            isModalActive: false,
            escorterModal: false,
            modalTitle: `${this.$t('new_tracking')}`,
        }
    },
    methods: {
        submit() {
            // format the dates
            if (this.inputs.loading_date != null) {
                this.inputs.loading_date = moment(this.inputs.loading_date).format('YYYY-MM-DD');
            }

            if (this.inputs.dispatched_at != null) {
                this.inputs.dispatched_at = moment(this.inputs.dispatched_at).format('YYYY-MM-DD');
            }

            if (this.inputs.exit_date != null) {
                this.inputs.exit_date = moment(this.inputs.exit_date).format('YYYY-MM-DD');
            }

            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },

        openEscorterModal() {
            this.$emit('openEscorterModal');
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    created() {
        this.$store.dispatch('getClients');
        this.$store.dispatch('getProducts');
        this.$store.dispatch('getSites');
        this.$store.dispatch('getTransporters');
        this.$store.dispatch('getLocations');
        this.$store.dispatch('getDestinations');
        this.$store.dispatch('getTransits');
        this.$store.dispatch('getStatus');
        this.$store.dispatch('getEscorters');
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>